<template>
  <svg
    width="11"
    height="2"
    viewBox="0 0 11 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.834635 1.66536C0.466446 1.66536 0.167969 1.36689 0.167969 0.998698C0.167969 0.630508 0.466445 0.332031 0.834635 0.332031H10.168C10.5362 0.332031 10.8346 0.630508 10.8346 0.998698C10.8346 1.36689 10.5362 1.66536 10.168 1.66536H0.834635Z"
    />
  </svg>
</template>
